import { render, staticRenderFns } from "./CreateGeneralKasbon.vue?vue&type=template&id=60d20995"
import script from "./CreateGeneralKasbon.vue?vue&type=script&lang=js"
export * from "./CreateGeneralKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports